// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"96":"b2857513","941":"0a448efb"}[chunkId] + ".js";
};